import { createSlice } from "@reduxjs/toolkit";

export const printReducer = createSlice({
  name: "Print",
  initialState: {
    isPrint: false,
    verifInformation: false,
    isShowModal: false,
    dataPrint: null,
  },
  reducers: {
    tooglePrint: (state) => {
      const newIsPrint = !state.isPrint;
      return { ...state, isPrint: newIsPrint };
    },
    toogleVerifInfo: (state) => {
      const newVerifInformation = !state.verifInformation;
      return { ...state, verifInformation: newVerifInformation };
    },
    showModal: (state) => {
      const newElement = !state.isShowModal;
      return { ...state, isShowModal: newElement };
    },
    addItemInDataPrint: (state, action) => {
      console.log("addItemInDataPrint", action.payload);
      return { ...state, dataPrint: action.payload };
    },
  },
});

export const { tooglePrint, toogleVerifInfo, showModal, addItemInDataPrint } =
  printReducer.actions;

export default printReducer.reducer;
